/**
 * @flow
 * @file i18n messages
 * @author Box
 */

import { defineMessages } from 'react-intl';

const messages = defineMessages({
    blockedByShieldAccessPolicy: {
        id: 'be.additionalTab.blockedByShieldAccessPolicy',
        defaultMessage: 'Use of this app is blocked due to a security policy.',
        description: 'Text to display when app is disabled by applied access policy',
    },
});

export default messages;
